import { borderRadiusMd, borderRadiusSm, spacing2x, spacing3x, spacing4x, spacing5x, spacing6x, } from "@airhelp/design-tokens";
export function getSelectStyles() {
    return {
        container: (provided) => ({
            ...provided,
            width: "100%",
        }),
        placeholder: (provided) => ({
            ...provided,
            color: "greyscale.500",
            marginRight: 0,
        }),
        control: (provided, state) => ({
            ...provided,
            cursor: "pointer",
            borderBottomRadius: state.menuIsOpen ? 0 : borderRadiusMd,
            paddingY: `${spacing3x} !important`,
            paddingX: `${spacing4x} !important`,
            width: "auto",
            minWidth: "auto",
            minHeight: "auto",
            lineHeight: spacing5x,
            color: "font.primary",
            "> div": {
                padding: "unset",
            },
            _invalid: {
                borderColor: state.selectProps.tagColorScheme === "warning" ? "warning.600" : "danger.700",
                _hover: {
                    borderColor: { md: state.selectProps.tagColorScheme === "warning" ? "warning.700" : "danger.800" },
                },
                _focus: {
                    borderColor: "primary.500",
                },
            },
            input: {
                maxHeight: spacing6x,
            },
        }),
        menu: (provided) => ({
            ...provided,
            margin: "unset",
            zIndex: "10",
        }),
        menuList: (provided) => ({
            ...provided,
            color: "greyscale.700",
            background: "greyscale.100",
            border: "1px solid",
            borderColor: "primary.500",
            borderTop: "none !important",
            borderTopRadius: 0,
            paddingX: "unset",
            paddingY: "unset",
            maxHeight: "12.25em",
            minWidth: "auto",
            "::-webkit-scrollbar": {
                width: spacing2x,
            },
            "::-webkit-scrollbar-track": {
                background: "greyscale.100",
                borderRadius: borderRadiusMd,
                marginBottom: "3px",
            },
            "::-webkit-scrollbar-thumb": {
                background: "greyscale.400",
                borderRadius: "24px",
            },
            "::-webkit-scrollbar-thumb:hover": {
                background: { md: "greyscale.400" },
            },
        }),
        option: (provided, state) => ({
            ...provided,
            paddingX: `${spacing4x} !important`,
            paddingY: `${spacing2x} !important`,
            background: state.isFocused || state.isSelected ? "primary.100" : "greyscale.100",
            color: state.isFocused || state.isSelected ? "primary.100" : "font.primary.500",
            borderRadius: borderRadiusSm,
            width: "auto",
            cursor: "pointer",
            _hover: {
                color: "primary.500",
                background: "primary.200",
            },
            _active: {
                color: "primary.500",
                background: "primary.200",
            },
            _focus: {
                color: "primary.500",
                background: "primary.200",
            },
            _selected: {
                color: "primary.500",
                background: "greyscale.100",
            },
        }),
        dropdownIndicator: (provided, state) => ({
            ...provided,
            background: state.isDisabled ? "greyscale.300" : "transparent",
            border: "none",
            color: state.selectProps.isDisabled ? "greyscale.500" : "greyscale.700",
            paddingX: "unset",
            transform: state.selectProps.menuIsOpen && "rotate(180deg)",
            display: "flex",
            justifyContent: state.selectProps.menuIsOpen ? "start" : "end",
            minWidth: "auto",
            svg: {
                boxSize: 5,
                color: "primary.900",
            },
        }),
        indicatorSeparator: (provided) => ({
            ...provided,
            display: "none",
        }),
        inputContainer: (provided) => ({
            ...provided,
            cursor: "text",
        }),
    };
}
